import React from 'react';
export function Footer() {
  return <footer className="bg-[#1a0f2e] text-gray-400 py-12 border-t border-white/10" data-id="element-56">
      <div className="container mx-auto px-4 text-center" data-id="element-57">
        <p className="mb-4 text-white font-serif italic text-lg" data-id="element-58">
          From Trauma to Self-Love
        </p>
        <div className="flex justify-center gap-6 text-sm" data-id="element-59">
          <a href="#" className="hover:text-white transition-colors" data-id="element-60">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-61">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-62">
            Contact Support
          </a>
        </div>
        <p className="mt-8 text-xs opacity-50" data-id="element-63">
          © {new Date().getFullYear()} All rights reserved.
        </p>
      </div>
    </footer>;
}